var _rect, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 165,
    viewBox: "0 0 117 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 165,
    rx: 7,
    fill: "#FFD97C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8281 62.0568C52.8281 56.3265 55.3719 51.2326 59.3159 48C63.2598 51.2326 65.8036 56.3265 65.8036 62.0568C65.8036 67.7871 63.2599 72.881 59.3159 76.1136C55.3719 72.881 52.8281 67.7871 52.8281 62.0568Z",
    fill: "url(#paint0_linear_3656_579)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4743 67.6046C43.5435 62.756 43.2181 57.0678 45.0997 52.1959C50.2879 52.7944 55.1731 55.7264 58.1039 60.575C61.0346 65.4236 61.36 71.1118 59.4784 75.9837C54.2902 75.3852 49.405 72.4532 46.4743 67.6046Z",
    fill: "url(#paint1_linear_3656_579)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.3106 67.6046C75.2414 62.756 75.5668 57.0678 73.6852 52.1959C68.497 52.7944 63.6118 55.7264 60.6811 60.575C57.7503 65.4236 57.4249 71.1118 59.3065 75.9837C64.4947 75.3852 69.3799 72.4532 72.3106 67.6046Z",
    fill: "url(#paint2_linear_3656_579)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2594 66.2594C33.0658 65.453 34.1596 65 35.3 65C36.1284 65 36.8 64.3284 36.8 63.5C36.8 62.6716 36.1284 62 35.3 62C33.3639 62 31.5071 62.7691 30.1381 64.1381C28.7691 65.5071 28 67.3639 28 69.3V98.3C28 100.236 28.7691 102.093 30.1381 103.462C31.5071 104.831 33.3639 105.6 35.3 105.6H38V108.75C38 109.578 38.6716 110.25 39.5 110.25H53.15C54.3037 110.25 55.4101 110.708 56.2259 111.524C57.0417 112.34 57.5 113.446 57.5 114.6C57.5 115.428 58.1716 116.1 59 116.1C59.8284 116.1 60.5 115.428 60.5 114.6C60.5 113.446 60.9583 112.34 61.7741 111.524C62.5899 110.708 63.6963 110.25 64.85 110.25H78.5C79.3284 110.25 80 109.578 80 108.75V105.6H81.7C83.6361 105.6 85.4929 104.831 86.8619 103.462C88.2309 102.093 89 100.236 89 98.3V69.3C89 67.3639 88.2309 65.5071 86.8619 64.1381C85.4929 62.7691 83.6361 62 81.7 62C80.8716 62 80.2 62.6716 80.2 63.5C80.2 64.3284 80.8716 65 81.7 65C82.8404 65 83.9342 65.453 84.7406 66.2594C85.547 67.0658 86 68.1596 86 69.3V98.3C86 99.4404 85.547 100.534 84.7406 101.341C83.9342 102.147 82.8404 102.6 81.7 102.6H80V79.5C80 78.6716 79.3284 78 78.5 78H66.8C64.3335 78 61.968 78.9798 60.2239 80.7239C59.7607 81.1871 59.3514 81.6942 59 82.2354C58.6486 81.6942 58.2393 81.1871 57.7761 80.7239C56.032 78.9798 53.6665 78 51.2 78H39.5C38.6716 78 38 78.6716 38 79.5V102.6H35.3C34.1596 102.6 33.0658 102.147 32.2594 101.341C31.453 100.534 31 99.4404 31 98.3V69.3C31 68.1596 31.453 67.0658 32.2594 66.2594ZM64.85 107.25C63.2757 107.25 61.7535 107.755 60.5 108.675V87.3C60.5 85.6291 61.1637 84.0267 62.3452 82.8452C63.5267 81.6637 65.1291 81 66.8 81H77V107.25H64.85ZM57.5 87.3V108.675C56.2465 107.755 54.7243 107.25 53.15 107.25H41V81H51.2C52.8709 81 54.4733 81.6637 55.6548 82.8452C56.8363 84.0267 57.5 85.6291 57.5 87.3Z",
    fill: "url(#paint3_linear_3656_579)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3656_579",
    x1: 59.3159,
    y1: 49.1068,
    x2: 59.3159,
    y2: 75.0068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCB12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF003D",
    stopOpacity: 0.03
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3656_579",
    x1: 45.6658,
    y1: 53.1324,
    x2: 58.9123,
    y2: 75.0472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCB12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF003D",
    stopOpacity: 0.03
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3656_579",
    x1: 73.1191,
    y1: 53.1324,
    x2: 59.8726,
    y2: 75.0472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCB12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF003D",
    stopOpacity: 0.03
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3656_579",
    x1: 58.5,
    y1: 64.1299,
    x2: 58.5,
    y2: 113.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCB12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF003D",
    stopOpacity: 0.03
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultBook);
export default __webpack_public_path__ + "static/media/defaultBook.30c9e0f9e7c5139f12bcc6d07d29b9ec.svg";
export { ForwardRef as ReactComponent };